import { blobPath, MAX_BLOB_BYTES, type BlobUploadResponse } from "./api.js";

export const MAX_CHAT_TEXT_BYTES = 1024 * 1024;
export const CHAT_ATTACHMENT_LIMITS = {
  textBytes: MAX_CHAT_TEXT_BYTES, downloadBytes: MAX_BLOB_BYTES,
  excerptChars: 64_000, contextChars: 128_000, contextFiles: 8,
  pageChars: 2_000, textAttemptMs: 15_000, downloadAttemptMs: 60_000,
  attempts: 2, contextMs: 20_000, uploadMs: 120_000,
} as const;
const textExtensions = new Set("md markdown mdx txt text log csv tsv json jsonl ndjson yaml yml toml xml html htm css scss js jsx mjs cjs ts tsx py rb rs go java c h cpp hpp cs sh bash sql graphql gql ini cfg conf diff patch r swift kt lua vue svelte".split(" "));
// An empty accept value lets the picker offer every file type.
export const CHAT_FILE_ACCEPT = "";

export function chatAttachmentKind(file: { mime: string; fileName: string }): "image" | "text" | "file" {
  const mime = file.mime.toLowerCase().split(";")[0]!.trim();
  if (mime.startsWith("image/")) return "image";
  if (mime.startsWith("text/") || /^(application\/(json|ld\+json|x-ndjson|xml|yaml|x-yaml|toml|javascript|x-javascript))$/.test(mime) ||
      textExtensions.has(file.fileName.split(".").at(-1)!.toLowerCase())) return "text";
  return "file";
}

export function isChatAttachment(value: BlobUploadResponse): boolean {
  return !!value && typeof value === "object" && typeof value.key === "string" && value.key.length > 0 &&
    value.url === blobPath(value.key) && typeof value.mime === "string" && typeof value.fileName === "string" &&
    Number.isSafeInteger(value.sizeBytes) && value.sizeBytes > 0 && value.sizeBytes <= MAX_BLOB_BYTES && !!chatAttachmentKind(value);
}

/** Reject binary data and invalid UTF-8 instead of silently replacing bytes. */
export function decodeChatText(bytes: Uint8Array): string {
  let text: string;
  try { text = new TextDecoder("utf-8", { fatal: true }).decode(bytes); }
  catch { throw new Error("This file is not UTF-8 text. Export it as UTF-8 text and try again."); }
  if (/[\u0000-\u0008\u000b\u000e-\u001f]/.test(text)) throw new Error("This file contains binary data. Attach a text file instead.");
  return text;
}
